module.exports = __webpack_public_path__ + "img/CRV.30cdcf72.svg";